import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutSidebarService {
  isFullscreen = signal<boolean>(false);
  isFullscreenOpen = signal<boolean>(false);
  isExpanded = signal<boolean>(true);
  isMobileOpen = signal<boolean>(false);
  isHovered = signal<boolean>(false);

  setExpanded(val: boolean) {
    this.isExpanded.set(val);
  }

  toggleExpanded() {
    this.isExpanded.update(v => !v);
  }

  setMobileOpen(val: boolean) {
    this.isMobileOpen.set(val);
  }

  toggleMobileOpen() {
    this.isMobileOpen.update(v => !v);
  }

  setHovered(val: boolean) {
    this.isHovered.set(val);
  }

  setFullscreen(val: boolean): void {
    this.isFullscreen.set(val);
    this.setExpanded(!val)
  }

  setFullscreenOpen(val: boolean): void {
    this.isFullscreenOpen.set(val);
  }

  toggleFullscreenOpen() {
    this.isFullscreenOpen.update(v => !v);
  }
}
